interface CryptoJson {
  privateKey: string;
  version?: string;
}

/**
 * 获取环境标识，用于区分测试和生产环境的密钥存储
 * 生产环境返回空字符串（保持兼容性），测试环境返回环境标识
 */
const getEnvironmentKey = (): string => {
  const env = process.env.VUE_APP_ENV;
  // 生产环境返回空字符串，保持完全兼容
  if (env === "production" || !env) {
    return "";
  }
  // 测试环境返回环境标识
  return `_${env}`;
};

/**
 * 生成存储键名，生产环境保持原样，测试环境增加环境标识
 */
const generateStorageKey = (userNo: string): string => {
  const envKey = getEnvironmentKey();
  return envKey ? `${userNo}${envKey}` : userNo;
};

export const getKeyChain = async (
  userNo: string
): Promise<CryptoJson | null> => {
  // 生成当前环境对应的存储键名
  const storageKey = generateStorageKey(userNo);

  const cryptoJson = (await window.electronAPI.loadPrivateKey(
    storageKey
  )) as CryptoJson;
  if (cryptoJson && cryptoJson.privateKey) {
    return cryptoJson;
  }
  return null;
};

export const saveKeyChain = async ({
  userNo,
  privateKey,
}: {
  userNo: string;
  privateKey: string;
}) => {
  // 生成当前环境对应的存储键名
  const storageKey = generateStorageKey(userNo);

  const cryptoJson = {
    privateKey,
    version: "1.0",
  };
  await window.electronAPI.savePrivateKey(storageKey, cryptoJson);
  return cryptoJson;
};
